import { useContext, useEffect, useRef, useState } from 'react';
import { VehicleDataVinApiResponse } from '../../../services/vehicle-data-service/vehicle-data-service.types';
import VehicleDataService from '../../../services/vehicle-data-service/vehicle-data-service';
import ServerContext from '../../../contexts/serverContext';

interface FeatureRibbonDataState {
    loading: boolean;
    data: VehicleDataVinApiResponse['vehicleDetails'] | null;
}

export const useFeatureRibbonData = (vin: string): FeatureRibbonDataState => {
    const vehicleDataService = useRef(new VehicleDataService());
    const { currentLanguageRegionCode } = useContext(ServerContext);

    const [hookState, setHookState] = useState<FeatureRibbonDataState>({
        loading: true,
        data: null,
    });

    async function getVinResponse(
        vin: string
    ): Promise<VehicleDataVinApiResponse | null> {
        return vehicleDataService.current
            .getVinVehicleData(currentLanguageRegionCode, vin)
            .then(res => {
                if (res?.vehicleDetails) {
                    return res;
                } else return null;
            });
    }

    useEffect(() => {
        if (vin !== '') {
            setHookState({ loading: true, data: null });
            getVinResponse(vin).then(res =>
                setHookState({
                    loading: false,
                    data: res?.vehicleDetails ?? null,
                })
            );
        }
    }, [vin]);

    return hookState;
};
